import { render } from "./RegisteredFulfill.vue?vue&type=template&id=05e6dec9"
import script from "./RegisteredFulfill.vue?vue&type=script&lang=js"
export * from "./RegisteredFulfill.vue?vue&type=script&lang=js"

import "./RegisteredFulfill.vue?vue&type=style&index=0&id=05e6dec9&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__